import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, retry, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { BackendChannelService } from './backend-channel.service';
import { BrowserUtils } from './browser-utils';
import { UsersService } from './users.service';

@Injectable()
export class UrlSwitcherInterceptor implements HttpInterceptor {
  constructor(
    private backendChannel: BackendChannelService,
    private userService: UsersService
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const currentChannel = this.backendChannel.$current.value;
    const baseUrl = this.backendChannel.getBaseUrl(currentChannel);
    const isPingRequest = req.url.includes('guest/usr/ping');
    const url = req.url.replace('API_BASE_URL', baseUrl);
    return next.handle(req.clone({ url })).pipe(
      catchError((error: HttpErrorResponse) => {
        const notSentRequest = error.status === 0 && !BrowserUtils.isUnload;
        if (isPingRequest && notSentRequest && currentChannel === 'proxy') {
          this.backendChannel.$connectStatus.next({ status: 'reconnecting', channel: 'main' });
          const mainUrl = req.url.replace('API_BASE_URL', this.backendChannel.getBaseUrl('main'));
          return next.handle(req.clone({ url: mainUrl })).pipe(
            retry({ delay: 1000, count: 2 }),
            map(event => {
              if (event instanceof HttpResponse && event.status === 200) {
                this.backendChannel.switchType('main');
              }
              return event;
            }),
            catchError(e => {
              this.backendChannel.$connectStatus.next({ status: 'reconnecting', channel: 'proxy' });
              return throwError(() => e);
            })
          );
        }
        return throwError(() => error);
      })
    );
  }
}
